export default "__VITE_ASSET__ku4N5Owj__"